import { PageInstance } from './page.service';
import { dependencies } from './workflow.dependency';

/**
 * A class to execute logic of a page action
 */
export class ActionPage {
  constructor(private readonly page: PageInstance) {
    if (!page.isActionPage) {
      throw new Error(`Page ${page.id} is not an action page`);
    }
  }

  /**
   * Because action pages are async we need to show an indicator, currently we show button indicator of the previous page
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public run(): Promise<any> {
    // Because action pages won't be rendered we can show loading indicator on the previous page
    // ToDo: Implement find the last actual page in case previous page is an action page
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const previousPage = this.page.previousPage || ({} as any);

    previousPage.actionLogicIsFailed = false;
    previousPage.actionButtonIsLoading = true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = dependencies.logicService.evaluate<Promise<boolean>>(
      this.page.config.actionLogic,
      {
        page: this.page
      },
      'generic'
    )[0];

    return result
      .then((res) => {
        previousPage.actionButtonIsLoading = false;
        return res;
      })
      .catch(() => {
        previousPage.actionButtonIsLoading = false;
        previousPage.actionLogicIsFailed = true;
        this.onError(previousPage);
      });
  }

  private onError(previousPage: PageInstance): void {
    if (typeof this.page.config.errorOnActionLogic === 'string') {
      if (previousPage?.config) previousPage.config.errorOnActionLogic = this.page.config.errorOnActionLogic;
      return;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
    const result = dependencies.logicService.evaluate<Promise<any>>(
      this.page.config.errorOnActionLogic,
      {
        page: this.page
      },
      'generic'
    )[0];
  }
}
